import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="group block"
    >
      <div
        className={`relative overflow-hidden rounded-lg mb-3 ${
          size === 'large' ? 'aspect-[3/4]' : 'aspect-[3/4]'
        }`}
      >
        <img
          src={comic.cover}
          alt={`${comic.title} - ${comic.category}漫画`}
          title={`${comic.title} | 土豪漫画网`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <div className="absolute top-2 left-2">
          <span
            className={`px-2 py-0.5 rounded-md text-[10px] font-medium ${
              comic.status === '连载中'
                ? 'bg-primary-500 text-background-50'
                : 'bg-secondary-500 text-background-50'
            }`}
          >
            {comic.status}
          </span>
        </div>

        <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 backdrop-blur-sm px-2 py-0.5 rounded-md">
          <i className="ri-star-fill text-accent-500 text-[10px]"></i>
          <span className="text-[10px] text-background-50 font-medium">{comic.rating}</span>
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>

      <div className="flex items-center gap-2 mt-1.5">
        {comic.tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="px-1.5 py-0.5 rounded bg-background-100 text-foreground-500 text-[10px]"
          >
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}